'use client';

import { useTranslations } from 'next-intl';
import { BookOpen, Calendar, Search } from 'lucide-react';

export function CatalogEmptyState() {
  const t = useTranslations('public.catalog');
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" role="status">
      <BookOpen className="h-12 w-12 text-muted-foreground/50 mb-4" aria-hidden="true" />
      <h2 className="text-xl font-semibold text-[#1e306e] mb-2">
        {t('comingSoonTitle')}
      </h2>
      <p className="text-muted-foreground max-w-md">
        {t('comingSoonBody')}
      </p>
    </div>
  );
}

/**
 * Program-aware empty catalog (Spec 2 / AC17). Distinct from
 * `CatalogEmptyState`'s "coming soon": here the platform HAS courses, just none
 * in the program this viewer is browsing — which is also what a family whose
 * only program was deactivated sees, instead of a 500.
 */
export function ProgramEmptyState() {
  const t = useTranslations('public.catalog');
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" role="status">
      <BookOpen className="h-12 w-12 text-muted-foreground/50 mb-4" aria-hidden="true" />
      <h2 className="text-xl font-semibold text-[#1e306e] mb-2">
        {t('programEmptyTitle')}
      </h2>
      <p className="text-muted-foreground max-w-md">{t('programEmptyBody')}</p>
    </div>
  );
}

export function CatalogNoResultsState({ searchTerm }: { searchTerm: string }) {
  const t = useTranslations('public.catalog');
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" role="status">
      <Search className="h-12 w-12 text-muted-foreground/50 mb-4" aria-hidden="true" />
      <h2 className="text-xl font-semibold text-[#1e306e] mb-2">
        {t('noResultsTitle')}
      </h2>
      <p className="text-muted-foreground max-w-md">
        {t('noResultsBody', { searchTerm })}
      </p>
    </div>
  );
}

export function MidTermEmptyState() {
  const t = useTranslations('public.catalog');
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" role="status">
      <Calendar className="h-12 w-12 text-muted-foreground/50 mb-4" aria-hidden="true" />
      <h2 className="text-xl font-semibold text-[#1e306e] mb-2">
        {t('midTermEmptyTitle')}
      </h2>
      <p className="text-muted-foreground max-w-md">
        {t('midTermEmptyBody')}
      </p>
    </div>
  );
}
